import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UserResolver = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('api_token');
        if (!token) {
            navigate('/login');
        }
        setLoading(false);
    }, [navigate]);

    if (loading) {
        return <div>Loading...</div>; // Or a nice spinner
    }

    return <>{children}</>;
};

export default UserResolver;